import { emailTriageTour } from './tours/emailTriageTour';
import { invoicesTour } from './tours/invoicesTour';
import { matchingTour } from './tours/matchingTour';
import { pflegedokuTour } from './tours/pflegedokuTour';
import { templatesTour } from './tours/templatesTour';
import { turnusTour } from './tours/turnusTour';
import type { FeatureTour } from './tourTypes';

// Sidebar menu key → guided preview on the real page with demo data. A locked
// or switched-off menu entry that has an entry here stays clickable and opens
// /feature-preview/<key> instead of showing a lock. Add a feature by writing a
// tour (fixtures + script) in tours/ and listing it here.
export interface FeaturePreviewEntry {
  /** i18n namespace under featurePreview.* (title, balloon texts, …). */
  ns: string;
  tour: FeatureTour;
}

export const FEATURE_PREVIEWS: Record<string, FeaturePreviewEntry> = {
  'email-triage': { ns: 'emailTriage', tour: emailTriageTour },
  matching: { ns: 'matching', tour: matchingTour },
  herzensapp: { ns: 'pflegedoku', tour: pflegedokuTour },
  invoices: { ns: 'invoices', tour: invoicesTour },
  templates: { ns: 'templates', tour: templatesTour },
  shifts: { ns: 'turnus', tour: turnusTour },
};

export const featurePreviewPath = (menuKey: string) => `/feature-preview/${menuKey}`;
